class Authentication {
  test = () => { };
  setAuthentication = (token, dataUser, customerSelect, email) => {
    localStorage.setItem('EmailUser', dataUser[0].Email ? dataUser[0].Email : email);
    localStorage.setItem('token', token);
    localStorage.setItem('dataUser', dataUser[0].UserId);
    localStorage.setItem('UserName', dataUser[0].Name);
    localStorage.setItem('UserNameLast', dataUser[0].LastName);
    localStorage.setItem('RoleId', dataUser[0].RoleId);
    localStorage.setItem('Role', dataUser[0].Role);
    localStorage.setItem('DATAUSER', dataUser.toString());
    localStorage.setItem('customerSelect', JSON.stringify(customerSelect)); //FIXME: quitar
    localStorage.setItem('isLoggedIn', true);
    localStorage.setItem('Modules', JSON.stringify(dataUser[0].Modules));
  };
  getAuthentication = (value) => {
    return localStorage.getItem(value);
  };
  deleteAuthentication = (value) => {
    localStorage.removeItem(value);
  };
}

export default Authentication;
